<template>
    <el-dialog v-dialogDrag class="userDialog" width="1000px"
               :visible.sync="dialogVisible"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                运维申请单选择
            </div>
        </div>
        <div class="dialog_body">
            <div style="padding: 10px;height: 40px;margin-bottom:20px">
            <searchBar :searchData="searchData" @search="search">
            </searchBar>
            </div>
            <el-table
                    ref="treeTable"
                    :data="dataList"
                    height="400"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    @row-click="selRow"
                    border>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="departmentNameBill"
                        label="所属部门"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="billNo"
                        width="150"
                        label="运维申请单号">
                </el-table-column>
                <el-table-column
                        prop="billDate"
                        width="100"
                        label="账单日期">
                </el-table-column>
                <el-table-column
                        prop="applyBy"
                        width="100"
                        label="申请人">
                </el-table-column>
                <el-table-column
                        prop="departmentName"
                        width="100"
                        label="申请部门">
                </el-table-column>
                <el-table-column
                        prop="customerName"
                        width="150"
                        label="客户">
                </el-table-column>
                <el-table-column
                        prop="serviceType"
                        width="100"
                        label="服务类型">
                </el-table-column>
                <el-table-column
                        prop="urgencyType"
                        width="100"
                        label="紧急程度">
                </el-table-column>
                <el-table-column
                        prop="serviceAddress"
                        width="100"
                        label="服务地点">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        width="100"
                        label="备注">
                </el-table-column>
            </el-table>

            <div class="pagStyle">
                <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import searchBar from '@/components/tools/toolBar/searchBar/build'
    import pagination from "@/components/tools/table/pagination";

    export default {
        name: "selOrder",
        props: ['relaBillId', 'loading','customerId'],
        components:{
            searchBar,pagination
        },
        data() {
            return {
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "用户名称",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                dialogVisible: true,
                dialoading: false,
                dataList: [],
            }
        },
        async mounted() {
            await this.getListData();
            if(this.relaBillId){
                this.defaultSelect();
            }
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async search(){
                this.pageInfo.page = 1;
                await this.getListData();
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/applyfor/listSel",
                    param: {
                        ...this.searchData.formData,
                        customerId:this.customerId,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.data;
                    this.pageInfo.total = data.data.count;
                }
                this.dialoading = false;
            },
            selRow(row){
                this.$emit("checkRow",row);
            },
            //默认选中
            defaultSelect() {
                this.$nextTick(() => {
                    let selrow = this.dataList.find(item => {
                        return item.billId == this.relaBillId
                    })
                    this.$refs.treeTable.setCurrentRow(selrow);
                });
            },
            toPage(obj) {
                this.getListData();
            },
        },
    }
</script>

